import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import PopupProfileEdit from "../../pages/popup/PopupProfileEdit"
import ModelOptionCard from "../../components/ModelOptionCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { logIn, updateMarketingAcceptance } from '../../redux/usersSlice';
import { setLang } from '../../redux/langSlice';
import moment from "moment";

export default function ProfileEdit() {
    const location = useLocation();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const lang = useSelector(state => state.langReducer.lang);

    const { mbData } = useSelector((s) => s.usersReducer);

    const fileRef = useRef();

    const [pwValue, setPwValue] = useState('*'.repeat(mbData?.pwCount));
    const [nameValue, setNameValue] = useState(mbData?.mb_name);
    const [coupon, setCoupon] = useState([]);
    const [googleLogins, setgoogleLogins] = useState(false);

    const [couponCount, setCouponCount] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        console.log(mbData);
        setPwValue('*'.repeat(mbData?.pwCount));
        setNameValue(mbData?.mb_name);
    }, [mbData?.pwCount, mbData?.mb_name]);

    useEffect(() => {
        if (!mbData?.idx) {
            navigate(routes.main);
        } else {
            CouponListFunc();
        }
    }, []);
    const CouponListFunc = async () => {
        dispatch(loadingStart());
        const ckresult = await API.xsollaApis("user/userinfos", { idx: mbData?.idx });
        console.log(ckresult);
        setgoogleLogins(ckresult?.result);

        

        const result = await API.xsollaApis("user/couponlists", { idx: mbData?.idx });
        if(result?.status === 200){
            let lists = [];
            result?.result?.couponsendlist?.filter(item => item?.email === mbData?.mb_email?.toLowerCase() && item?.status*1 === 0 && item?.validityDate > moment().format('YYYY-MM-DD HH:mm:ss') )?.map((x, i) => {
                let coupongrouplists = result?.result?.coupongrouplist?.find(item => item?.idx*1 === x?.couponIdx*1);
                x.issueType = coupongrouplists?.couponCode;
                x.discount = coupongrouplists?.discount;
                x.issueDate = moment(coupongrouplists?.create_dt).format('YYYY-MM-DD HH:mm:ss');
                x.statusTxt = x?.status === 0 ? '미사용' : x?.validityDate < moment().format('YYYY-MM-DD HH:mm:ss') ? '만료' : '사용';
                lists.push(x);
                //return x;
            });
            console.log(lists, mbData);
            setCoupon(lists);
        }
        dispatch(loadingEnd());
    }

    const [selectedLang, setSelectedLang] = useState(mbData?.emailLanguage);
    const handleLangChange = (e) => {
        setSelectedLang(e.target.value);
    };

    //console.log("mbData : ", mbData, ", selectedLang : ", selectedLang, ", selectedLang === 'ko' : ", (selectedLang === 'ko'));

    useEffect(() => {
        if (selectedLang != mbData?.emailLanguage) {
            dispatch(loadingStart());
            API.patch("user", { id: mbData?.idx, emailLanguage: selectedLang }, true)
                .then(res => {
                    console.log("res : ", res.data);
                    if (res.data) {
                        dispatch(logIn({ mbData: {...mbData, emailLanguage: selectedLang} }));
                        //dispatch(setLang(selectedLang === 'ko' ? 0 : 1));
                    }
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    dispatch(loadingEnd());
                });
        }
    }, [selectedLang]);

    const changeAccept = () => {
        const isAccept = mbData?.isAcceptMarketingActivities === 1 ? 0 : 1;
        dispatch(loadingStart());
        const data = { id: mbData?.idx, isAcceptMarketingActivities: isAccept };
        API.patch("user", data, true)
            .then(res => {
                console.log("res : ", res.data.message);
                if (res.data) {
                    dispatch(updateMarketingAcceptance(isAccept));
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                dispatch(loadingEnd());
            });
    };

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "profile_password") {
            setPwValue(value)
        }

        if (name === "profile_name") {
            setNameValue(value)
        }
    }

    const openEdit = (type) => {
        if (type === "password") {
            dispatch(open({
                component:
                    <PopupProfileEdit
                        x_btn={false}
                        popType={'password'}
                        button={lang === 0 ? '비밀번호 변경' : 'Change Password'}
                        buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                    />
            }));
        }

        if (type === "name") {
            dispatch(open({
                component:
                    <PopupProfileEdit
                        x_btn={false}
                        popType={'name'}
                        button={lang === 0 ? '저장' : 'Save'}
                        buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                    />
            }));
        }

        if (type === "leave") {
            dispatch(open({
                component:
                    <Popup01
                        x_btn={false}
                        leave={true}
                    />
            }));
        }
    }


    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box">
                        <div
                            className="title_box"
                            onClick={() => {
                                // navigate(-1);
                                navigate(routes.Profile);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default} />
                            <p>{lang === 0 ? '프로필' : 'Profile'}</p>
                        </div>

                        <div className="profile_edit">
                            <div className="profile_info">
                                <p className="title">{lang === 0 ? '이메일' : 'Email'}</p>
                                {mbData?.mb_type == 1 &&
                                    <img src={require("../../assets/icon/google_logo.svg").default} />
                                }
                                <p className="email">{mbData?.mb_email}</p>
                            </div>
                            {googleLogins === false &&
                            <div className="profile_info">
                                <p className="title">{lang === 0 ? '비밀번호' : 'Password'}</p>
                                <input
                                    type="password"
                                    name="profile_password"
                                    placeholder={lang === 0 ? "비밀번호" : "Password"}
                                    value={pwValue}
                                    onChange={InputChange}
                                    maxLength={15}
                                    readOnly
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        openEdit("password")
                                    }}
                                >
                                    {lang === 0 ? '변경' : 'Change'}
                                </button>
                            </div>}

                            <div className="profile_info">
                                <p className="title">{lang === 0 ? '이름' : 'Name'}</p>
                                <input
                                    type="text"
                                    name="profile_name"
                                    placeholder={lang === 0 ? "미입력" : "Not Set"}
                                    maxLength={10}
                                    value={nameValue}
                                    onChange={InputChange}
                                    readOnly
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        openEdit("name")
                                    }}
                                >
                                    {lang === 0 ? '변경' : 'Change'}
                                </button>
                            </div>

                            <div className="profile_info">
                                <p className="title">{lang === 0 ? '나의 쿠폰' : 'My Coupon'}</p>
                                <span className="coupon">{lang === 0 ? '사용 가능' : 'Available'}</span>
                                <b>{coupon?.length}</b>
                                <button
                                    type="button"
                                    onClick={() => {
                                        navigate(routes.ProfileCoupon)
                                    }}
                                >
                                    {lang === 0 ? '내역' : 'History'}
                                </button>
                            </div>

                            <div className="profile_info">
                                <p className="title">{lang === 0 ? '뉴스레터 수신' : 'Newsletter Subscription'}</p>

                                <div className="custom_chk_box inquiry profile">
                                    <input
                                        type="checkbox"
                                        className="custom_chk_input"
                                        id="profile_sns"
                                        checked={mbData?.isAcceptMarketingActivities === 1}
                                        onChange={changeAccept}
                                    />
                                    <label htmlFor="profile_sns" className="custom_chk_label">
                                        {lang === 0 ? '등록된 이메일로 새로운 소식을 받습니다.' : 'Receive updates via email.'}
                                    </label>
                                </div>
                            </div>

                            <div className="profile_info">
                                <p className="title">{lang === 0 ? '이메일 수신 언어' : 'Email Language'}</p>

                                <div className="custom_chk_box profile lang left">
                                    <input
                                        type="radio"
                                        className="custom_chk_input"
                                        name="profile_email_lang"
                                        id="profile_email_lang1"
                                        value={'ko'}
                                        checked={selectedLang === 'ko'}
                                        onChange={handleLangChange}
                                    />
                                    <label htmlFor="profile_email_lang1" className="custom_chk_label">
                                        {lang === 0 ? '한국어' : 'Korean'}
                                    </label>
                                </div>

                                <div className="custom_chk_box profile lang">
                                    <input
                                        type="radio"
                                        className="custom_chk_input"
                                        name="profile_email_lang"
                                        id="profile_email_lang2"
                                        value={'en'}
                                        checked={selectedLang === 'en'}
                                        onChange={handleLangChange}
                                    />
                                    <label htmlFor="profile_email_lang2" className="custom_chk_label">
                                        {lang === 0 ? '영어' : 'English'}
                                    </label>
                                </div>
                            </div>

                            <div className="profile_info btm_last">
                                <p className="title">{lang === 0 ? '회원탈퇴' : 'Delete Account'}</p>
                                <span
                                    className="leave"
                                    onClick={() => {
                                        openEdit("leave")
                                    }}
                                >
                                    {lang === 0 ? '탈퇴하기' : 'Leave'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
